/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmartCropMode = {
    Centre: 'Centre',
    Attention: 'Attention',
    Entropy: 'Entropy',
    High: 'High',
    Low: 'Low'
} as const;
export type SmartCropMode = typeof SmartCropMode[keyof typeof SmartCropMode];


export function SmartCropModeFromJSON(json: any): SmartCropMode {
    return SmartCropModeFromJSONTyped(json, false);
}

export function SmartCropModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmartCropMode {
    return json as SmartCropMode;
}

export function SmartCropModeToJSON(value?: SmartCropMode | null): any {
    return value as any;
}

/**
 * Check if a given object implements the SmartCropMode interface.
 */
 export function instanceOfSmartCropMode(value: any): value is SmartCropMode {
    return Object.values(SmartCropMode).includes(value)
}

